import cn from 'classnames';
import { compact } from 'lodash-es';
import { Button, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from "../../../constants";
import { useStore } from "../../../contexts";
import { useSwitchBusiness } from "../../../hooks/useSwitchBusiness";
import { selectors } from "../../../store/state-selectors";
import { BusinessSwitcherForSpecificUsers } from "../BusinessSwitcher/BusinessSwitcher";
import { HelpMenu } from "../HelpMenu";
import { InAppNotificationsButton } from "../InAppNotificationsButton";
import UserMenu from "../UserMenu/UserMenu";
import styles from "./TopBar.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getTopBarTID = () => getTestIds();
export function TopBar() {
  const userInfo = useStore(state => state.userInfo);
  const userId = useStore(selectors.user.id);
  const isVendor = useStore(selectors.user.isVendor);
  const businessName = useStore(selectors.user.businessName);
  const isAccountant = useStore(selectors.user.isAccountant);
  const isAnchorAdmin = useStore(selectors.user.isAnchorAdmin);
  const {
    switchBusiness,
    getPrevBusinessId
  } = useSwitchBusiness();
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": getTopBarTID().TopBarTID.Root(),
    className: cn(styles.root, {
      [styles.accountant]: isAccountant,
      [styles.anchorAdmin]: isAnchorAdmin
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.start,
      children: [isAccountant && /*#__PURE__*/_jsxs("div", {
        className: styles.accountantSection,
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph2",
          children: ["You are now logged in to", ' ', /*#__PURE__*/_jsx(Typography, {
            as: "span",
            variant: "paragraph2",
            weight: "normal",
            children: businessName
          })]
        }), /*#__PURE__*/_jsx(Button, {
          className: styles.backBtn,
          size: "small",
          skin: "primaryOutline",
          "data-testid": getTopBarTID().TopBarTID.BackToMyBusiness(),
          onClick: () => switchBusiness(getPrevBusinessId(), {
            newRoute: routes.agreementsDashboard
          }),
          children: "Back to my business"
        })]
      }), isAnchorAdmin && businessName && /*#__PURE__*/_jsx(AnchorAdmin, {
        companyName: businessName
      }), /*#__PURE__*/_jsx(BusinessSwitcherForSpecificUsers, {})]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.end,
      "data-testid": getTopBarTID().TopBarTID.EndContainer(isVendor ? 'vendor' : 'client'),
      children: compact([{
        id: 'marketing-content',
        value: null
      }, {
        id: 'help',
        value: userId && /*#__PURE__*/_jsx(HelpMenu, {})
      }, isVendor && {
        id: 'in-app-notifications',
        value: /*#__PURE__*/_jsx(InAppNotificationsButton, {})
      }, userId && {
        id: 'user',
        value: /*#__PURE__*/_jsx(UserMenu, {
          userInfo: userInfo
        })
      }]).map(_ref => {
        let {
          id,
          value
        } = _ref;
        return /*#__PURE__*/_jsx("div", {
          "data-testid": getTopBarTID().TopBarTID.EndItem(id),
          className: styles.endItem,
          children: value
        }, id);
      })
    })]
  });
}
const AnchorAdmin = _ref2 => {
  let {
    companyName
  } = _ref2;
  return /*#__PURE__*/_jsxs(Typography, {
    variant: "paragraph2",
    breakWords: true,
    children: ["You are now logged as an Anchor Admin to", ' ', /*#__PURE__*/_jsx(Typography, {
      as: "span",
      weight: "bold",
      children: companyName
    })]
  });
};